<div>
  <div class="table-header">
    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="pi pi-search"></i>
      </p-inputgroup-addon>
      <input
        pInputText
        placeholder="Username"
        (input)="search$.next($any($event.target).value)" />
    </p-inputgroup>
  </div>

  <div class="col-12">
    <p-table
      #dt
      stripedRows
      [paginator]="false"
      [value]="importUsers"
      [(selection)]="selectedUsers"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      scrollHeight="calc(100vh - 200px)"
      [size]="'small'"
      [resizableColumns]="false"
      [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]"
      [loading]="loading"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [filterDelay]="0"
      selectionMode="multiple"
      styleClass="table-listing usertooltip">
      <ng-template pTemplate="caption"> </ng-template>

      <ng-template pTemplate="header">
        <tr class="table-head">
          <th>
            <p-tableHeaderCheckbox
              [disabled]="!loadingComplete"></p-tableHeaderCheckbox>
          </th>
          <th>Name</th>
          <th>Email</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-importUser let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pSelectableRow]="importUser"
          [pSelectableRowIndex]="rowIndex">
          <td>
            <p-tableCheckbox [value]="importUser"></p-tableCheckbox>
          </td>
          <td
            pTooltip="{{ importUser.displayName }}"
            tooltipPosition="top"
            placeholder="Top">
            <span class="text-trim text-truncate">{{
              importUser.displayName
            }}</span>
          </td>
          <td
            pTooltip="{{
              getLoginEmail(importUser.userPrincipalName, importUser.mail)
            }}"
            tooltipPosition="top"
            placeholder="Top">
            <span class="text-trim text-truncate">{{
              getLoginEmail(importUser.userPrincipalName, importUser.mail)
            }}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No users found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="d-flex p-3 d-flex justify-content-end importuser-button">
    <p-button
      label="Import Users"
      (click)="importUsersHandler()"
      [disabled]="!selectedUsers.length" />
    <!-- <p-button label="Sync Users" (click)="getAndSyncUserMails()" /> -->
  </div>
</div>
